import { RECAPTCHA_KEY } from '../../utils/constants'

export const nameRegExp = /^(([a-z]+((-?[a-z]+)?|( ?[a-z]+){0,2}))|([а-яА-Я]+((-?[а-яА-Я]+)?|( ?[а-яА-Я]+){0,2})))?$/i
export const emailRegExp =
  /^(?=.{1,64}@)(?=.*@.{1,253})(?=(.*@.{1,63}\.)|(.*@.{1,63}$))([a-z0-9#\-_~!$&'()*+,;=:%]+(\.[a-z0-9#\-_~!$&'()*+,;=:%]+)*)@((((([a-z]+)|([0-9]+[a-z\-]+))[[a-z0-9\-]*)(\.[a-z0-9-]{1,64})*)|(\[[0-9]{3}.[0-9]{3}.[0-9]{3}.[0-9]{3}]))$/i
export const phonePattern = /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){11,14}(\s*)?$/
export const defaultPattern = /.*\S.*/
export const forbiddenCharsRegExp = /^[\u{0000}-\u{D7FF}\u{E000}-\u{FFFF}]+$/u
export const defaultMaxLength = 100

export const mailMessages = {
  fail: 'Something went wrong!',
  success: 'Thanks!',
}

export const SHOW_MESSAGE_DURATION = 10000

export const FORM_CONSTRAINTS = {
  file: {
    maxSize: 10485760,
    extensions: ['pdf', 'doc', 'docx', 'rtf', 'jpeg', 'jpg', 'png'],
  },
  firstName: {
    maxLength: 40,
  },
  lastName: {
    maxLength: 50,
  },
  email: {
    maxLength: 100,
  },
  phone: {
    maxLength: 30,
  },
  message: {
    maxLength: 1024,
  },
  companyName: {
    maxLength: 100,
  },
  city: {
    maxLength: 100,
  },
  event: {
    maxLength: 255,
  },
  interests: {
    maxLength: 1024,
  },
  recaptcha: {
    key: RECAPTCHA_KEY ? RECAPTCHA_KEY : '',
  },
}

const validateEmail = (email: string, _: string) => {
  if (!emailRegExp.test(email)) {
    return 'Email is invalid.'
  }

  return true
}

export const validateDefault = (field: string, text: string) => {
  if (field.trim().length === 0) {
    return `${text} cannot be empty.`
  }
  if (!forbiddenCharsRegExp.test(field) || !defaultPattern.test(field)) {
    return `${text} is invalid.`
  }

  return true
}

export const validateName = (name: string, text: string) => {
  if (!nameRegExp.test(name)) {
    return `${text} is invalid.`
  }

  return true
}

export const FIELDS_VALIDATION = {
  email: validateEmail,
  name: validateName,
  default: validateDefault,
}
